'use client'
import clsx from 'clsx'
import { useState } from 'react'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { cn } from '@/lib/utils'

export type DropdownOptionsType = { label: string; value: string }[]

export const Dropdown = ({
  error = '',
  onChange,
  label,
  defaultValue,
  disabled,
  options = [],
  placeholder = 'Select an option',
  triggerClassName,
  icons,
}: {
  error?: string
  onChange?: (e: string) => void
  label?: string
  defaultValue?: string
  disabled?: boolean
  options: DropdownOptionsType
  placeholder?: string
  triggerClassName?: string
  icons?: {
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
  }
}) => {
  const [hasValue, setHasValue] = useState(defaultValue ? true : false)
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className={clsx('relative flex w-full min-w-0 md:min-w-[268px]')}>
      <label className="flex w-full flex-col gap-2">
        <Select
          onValueChange={(e) => {
            setHasValue(!!e)
            if (onChange) onChange(e)
          }}
          disabled={!!disabled}
          defaultValue={defaultValue}
        >
          <SelectTrigger
            error={error}
            leftIcon={icons?.leftIcon}
            rightIcon={icons?.rightIcon}
            className={clsx(hasValue && 'pt-6 ', triggerClassName)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setIsFocused(false)
            }}
          >
            <SelectValue placeholder={!label && placeholder} />
          </SelectTrigger>

          <SelectContent>
            {options?.map(({ value, label }, index) => (
              <SelectItem value={value} key={`${value}-${index}`} className={cn(!hasValue && 'pl-3')}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {label && (
          <p
            className={clsx(
              'absolute start-3 top-3 z-1 origin-0 text-base duration-300',
              hasValue || isFocused ? '-translate-y-2 text-xs' : '',
              error ? 'text-error-700' : `${isFocused ? 'text-primary-500' : 'text-grey-500'}`,
              disabled ? 'text-grey-500' : '',
            )}
          >
            {label}
          </p>
        )}
        {error && <p className="text-sm font-medium text-error-500">{error}</p>}
      </label>
    </div>
  )
}
